import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import type { FlaggedProps } from './Profile';
import Profile from './Profile';
import {
  canChangeLanguage,
  canEditBillingAddressOnProfile,
  canChangeContactNumber,
  canChangeMarketingApproval,
} from '../../config';
import env from '../../config/env';
import { customerSelector, hasBillingAddressSelector } from '../../modules/Customer/selectors';

const mapStateToProps = state => ({
  customer: customerSelector(state),
  hasBillingAddress: hasBillingAddressSelector(state),
});

const withFlaggedProps = (): FlaggedProps => ({
  canEditBillingAddress: canEditBillingAddressOnProfile,
  canChangeContactNumber,
  canChangeMarketingApproval,
  canChangeLanguage,
  env,
});

export default compose(connect(mapStateToProps), withProps(withFlaggedProps))(Profile);
